import React, {useEffect} from "react";
import {connect} from "react-redux";

import {setWizardPopupEditToggles} from "../../wizardActions";
import {FormattedMessage} from "react-intl";
import CheckBox from "../../../PageLayout/CheckBox";

const checkboxes = {
  "hideItems": "Hides layers in the visualizer and makes them visible on steps selections",
  "hideContext": "Opens the wizard on the visualizer click instead of the context menu if clicked feature group has context menu and the wizard contains this group",
  "skipStartStep": "Opens the wizard on the first selections step skipping intro",
  "hideInMenu": "Hides wizard from the navigation menu",
  "openWizardOnClick": "Opens the wizard on the visualizer click and category click instead of the regular menu if the first wizard group was clicked",
};

const WizardPopupItemToggles = (props) => {

  const {wizardPopupItem, wizardPopupEditToggles, setWizardPopupEditToggles} = props;
  const checkboxesArray = Object.keys(checkboxes);

  useEffect(() => {
    const newObj = checkboxesArray.reduce((obj, checkboxProperty) => {
      obj[checkboxProperty] = wizardPopupItem[checkboxProperty];
      return obj
    }, {})
    setWizardPopupEditToggles(newObj);
    return () => {
      setWizardPopupEditToggles({})
    }
  }, [])

  const checkboxClick = (property) => {
    setWizardPopupEditToggles({...wizardPopupEditToggles, [property]: !wizardPopupEditToggles[property]});
  }

  return (
    <div className="fs-toggle-popup__table">
      <div className="wizard-popup__title">
        <h3>{wizardPopupItem.name} Settings</h3>
      </div>
      {checkboxesArray.map(checkboxProperty => {
        return (
          <div className="fs-toggle-popup__table-row bordered" key={checkboxProperty}>
            <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name ui-legend">
              <FormattedMessage id={checkboxProperty === "skipStartStep" ? "wizard.popup.skipStartStep" : "wizard.item.checkbox." + checkboxProperty}/>
              <div className="ui-legend__info secondary">{checkboxes[checkboxProperty]}</div>
            </div>
            <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox">
              <CheckBox checked={!!wizardPopupEditToggles[checkboxProperty]}
                        innerStyle="none"
                        type={"medium"}
                        disabled={false}
                        onChecked={() => checkboxClick(checkboxProperty)}
                        text=""/>
            </div>
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupItem, wizardPopupEditToggles} = store.wizardState;

  return {
    wizardPopupItem,
    wizardPopupEditToggles,
  };
};

const mapDispatchToProps = {
  setWizardPopupEditToggles,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupItemToggles)
)
